<template>
  <div style="height: inherit">
    <!-- Stock Header -->
    <section id="ecommerce-header">
      <div class="row">
        <div class="col-sm-12">
          <div class="ecommerce-header-items">
            <div class="result-toggler">
              <feather-icon
                  class="d-block d-lg-none"
                  icon="MenuIcon"
                  size="21"
                  @click="mqShallShowLeftSidebar = true"
              />
              <div v-if="filters.q" class="search-results">
                {{ dataMeta.of }} résultat(s) trouvé(s)
              </div>
            </div>
            <div class="view-options d-flex">
              <!--  Handle release -->
              <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  :to="{ name: 'apps-stock-stores-release-products', params: { id: $route.params.id} }"
                  class="mr-1"
                  variant="warning"
              >
                <feather-icon class="mr-50" icon="CalendarIcon"/>
                <span class="align-middle">Planification</span>
              </b-button>

              <!-- Other actions-->
              <b-dropdown text="Autres Actions" variant="primary">
                <!-- Handle stock -->
                <b-dropdown-item @click="toggleStockModal = true">
                  <feather-icon icon="ClipboardIcon"/>
                  <span class="align-middle ml-50">Approvisionnement</span>
                </b-dropdown-item>
                <b-dropdown-item :to="{ name: 'apps-stock-stores-history', params: { id: $route.params.id } }">
                  <feather-icon icon="ListIcon"/>
                  <span class="align-middle ml-50">Historique</span>
                </b-dropdown-item>
                <b-dropdown-item @click="openStockForm('add')">
                  <feather-icon icon="PlusIcon"/>
                  <span class="align-middle ml-50">Ajouter un nouveau Stock</span>
                </b-dropdown-item>
              </b-dropdown>

              <!-- Sort Button -->
              <b-dropdown
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :text="filterOnStock.name"
                  class="ml-1"
                  right
                  variant="outline-primary"
              >
                <b-dropdown-item
                    v-for="stockOption in filterOnStockOptions"
                    :key="stockOption.slug"
                    @click="filterOnStock = stockOption"
                >
                  {{ stockOption.name }}
                </b-dropdown-item>
              </b-dropdown>

              <!-- Item View Radio Button Group  -->
              <b-form-radio-group
                  v-model="itemView"
                  button-variant="outline-primary"
                  buttons
                  class="ml-1 list item-view-radio-group"
                  size="sm"
              >
                <b-form-radio
                    v-for="option in itemViewOptions"
                    :key="option.value"
                    :value="option.value"
                >
                  <feather-icon :icon="option.icon" size="18"/>
                </b-form-radio>
              </b-form-radio-group>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Stock Header -->
    <div class="body-content-overlay"/>

    <!-- Overlay -->
    <div class="ecommerce-searchbar mt-1">
      <b-row>
        <b-col cols="12">
          <b-input-group class="input-group-merge">
            <b-form-input
                v-model="filters.q"
                class="search-product"
                placeholder="Recherche Produit"
            />
            <b-input-group-append is-text>
              <feather-icon class="text-muted" icon="SearchIcon"/>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </div>

    <!-- Searchbar -->
    <section v-if="products.length > 0" :class="itemView">
      <b-card
          v-for="(product, index) in products"
          :key="index"
          class="ecommerce-card"
          no-body
      >
        <div class="item-img text-center">
          <b-link
              :to="{
              name: 'apps-stock-product-details',
              params: { id: product.details.store, stock_id: product.details.stock, product_id: product.uid }
            }"
          >
            <b-img
                :alt="`${index}`"
                :src="product.image"
                class="card-img-top"
                fluid
            />
          </b-link>
        </div>

        <!-- Product Details -->
        <b-card-body>
          <div class="item-wrapper">
            <div class="item-rating">
              <feather-icon
                  :icon="product.is_depreciable ? 'ArrowRightIcon' : 'RotateCcwIcon'"
                  class="text-warning"
                  size="16"
              />
            </div>
            <div>
              <h6
                  :class="[
                  productAvailableInStock(product) ? 'text-success' : 'text-danger',
                ]"
                  class="item-price"
              >
                {{
                  productAvailableInStock(product) ? "Disponible (" + product.details.available + ")" : "Indisponible"
                }}
              </h6>
            </div>
          </div>
          <h6 class="item-name">
            <b-link
                :to="{
                name: 'apps-stock-product-details',
                params: { id: product.details.store, stock_id: product.details.stock, product_id: product.uid },
              }"
                class="text-body"
            >
              {{ product.name }}
            </b-link>
            <b-card-text class="item-company">
              Par
              <b-link class="ml-25">
                {{ product.brand ? product.brand.name : "-" }}
              </b-link>
            </b-card-text>
          </h6>
          <b-card-text class="item-description">
            {{ product.details ? product.details.description : '' }}
          </b-card-text>
          <b-card-text class="item-description">
            {{ product.description }}
          </b-card-text>
        </b-card-body>

        <!-- Product Actions -->
        <div class="item-options text-center">
          <div class="item-wrapper">
            <div class="item-cost">
              <h4
                  :class="[
                  productAvailableInStock(product) ? 'text-success' : 'text-danger',
                ]"
                  class="item-price"
              >
                {{
                  productAvailableInStock(product) ? "Disponible (" + product.details.available + ")" : "Indisponible"
                }}
              </h4>
            </div>
          </div>
          <b-button
              :disabled="!productAvailableInStock(product)"
              class="btn-wishlist"
              tag="a"
              variant="light"
              @click="planProductForRelease(product, 'booking', index)"
          >
            <feather-icon
                :icon="
                product.details.planned_mode === 'booking' ? 'PauseCircleIcon' : 'CalendarIcon'
              "
                class="mr-50"
            />
            <span>{{ product.details.planned_mode === 'booking' ? "Attente" : "Réserver" }}</span>
          </b-button>
          <b-button
              :disabled="!productAvailableInStock(product)"
              class="btn-cart"
              tag="a"
              variant="primary"
              @click="planProductForRelease(product, 'direct', index)"
          >
            <feather-icon
                :icon="product.details.planned_mode === 'direct' ? 'LogInIcon' : 'LogOutIcon'"
                class="mr-50"
            />
            <span>{{ product.details.planned_mode === 'direct' ? "Afficher" : "Sortir" }}</span>
          </b-button>
        </div>
      </b-card>
    </section>
    <section v-else :class="itemView">
      <i> Aucun produit trouvé pour ce stock. </i>
    </section>

    <!-- Prodcut pagination -->
    <section>
      <b-row>
        <b-col class="d-flex align-items-center justify-content-center justify-content-sm-start" cols="12" sm="6">
          <span class="text-muted"
          >Affichage de {{ dataMeta.from }} à {{ dataMeta.to }} sur {{ dataMeta.of }}</span
          >
        </b-col>
        <b-col class="d-flex align-items-center justify-content-center justify-content-sm-start" cols="12" sm="6">
          <b-pagination
              v-model="filters.page"
              :per-page="filters.perPage"
              :total-rows="dataMeta.of"
              align="center"
              first-number
              last-number
              next-class="next-item"
              prev-class="prev-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18"/>
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18"/>
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </section>

    <!--    handle stock modal-->
    <b-modal
        id="stock-modal"
        v-model="toggleStockModal"
        :cancel-disabled="isLoading"
        :ok-disabled="isLoading"
        centered
        ok-only
        ok-title="Fermer"
        title="Gérer Stocks"
    >
      <component
          :is="currentComponent"
          :loading.sync="isLoading"
          @stock-handled="stockComponent = 'Stocks List'"
      />
    </b-modal>

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-detached-left">
      <stocks-view-left-filter-sidebar
          :filter-options="filterOptions"
          :filters="filters"
          :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
      />
    </portal>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BFormRadio,
  BFormRadioGroup,
  BImg,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BModal,
  BPagination,
  BRow,
  VBModal,
} from "bootstrap-vue";

import Ripple from "vue-ripple-directive";

import {computed, ref, watch} from "@vue/composition-api";
import {useResponsiveAppLeftSidebarVisibility} from "@core/comp-functions/ui/app";
import {useStocksView} from "./useStocksView";

import StocksViewLeftFilterSidebar from "./StocksViewLeftFilterSidebar.vue";
import StocksViewStockForm from "./StocksViewStockForm.vue";
import StocksViewStocksList from "./StocksViewStocksList.vue";
import store from "@/store";
import {useRouter} from "@core/utils/utils";

export default {
  name: "StocksView",
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  components: {
    BModal,
    // BSV
    BDropdown,
    BDropdownItem,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BCard,
    BCardBody,
    BLink,
    BImg,
    BCardText,
    BButton,
    BPagination,

    // SFC
    StocksViewLeftFilterSidebar,
    StocksViewStocksList,
    StocksViewStockForm,
  },
  setup(props, {emit}) {
    const {router} = useRouter();

    const {
      filters,
      filterOptions,
      filterOnStock,
      filterOnStockOptions,
      itemView,
      itemViewOptions,
      dataMeta,
      products,
      fetchProducts,
      productAvailableInStock,
      showToast,
    } = useStocksView();

    const {mqShallShowLeftSidebar} = useResponsiveAppLeftSidebarVisibility();

    const stockComponent = ref("Stocks List");
    const toggleStockModal = ref(false);
    const isLoading = ref(false);

    const planProductForRelease = async (product, mode, currIndex) => {
      const response = await store.dispatch('stock/addProductToReleaseQueue',
          {
            stockId: product.details?.stock,
            productId: product.uid,
            data: {
              mode
            }
          }
      );

      if (!response.success) {
        const errorMessage = response.error
        if (errorMessage && typeof errorMessage === 'string') {
          showToast(errorMessage, "AlertTriangleIcon", "danger");
        } else {
          showToast(`Le produit ${product.name} n'a pas pu être ajouté à la liste de sortie.`, "AlertTriangleIcon", "danger");
        }
      } else {
        const list = [...products.value];
        list[currIndex].details.planned_mode = mode;
        products.value = list;
      }
    };

    const fetchStockProducts = () => {
      const queryParams = {
        q: filters.value.q,
        categories: filters.value.categories,
        brands: filters.value.brands,
        filterOnStock: filterOnStock.value.slug,
        page: filters.value.page,
        perPage: filters.value.perPage,
      };
      fetchProducts({
        store_id: router.currentRoute.params.id,
        query: queryParams,
      });
    };

    fetchStockProducts();

    watch(
        [filters, filterOnStock],
        () => {
          fetchStockProducts();
        },
        {
          deep: true,
        }
    );

    watch(
        toggleStockModal,
        (isOpened) => {
          if (!isOpened) stockComponent.value = "Stocks List";
        },
        {
          immediate: true,
        }
    );

    const initStockForm = () => {
      let blankStock = {
        name: "",
        description: "",
      };
      store.commit("stock/SET_RESOURCE", blankStock);
    };

    const currentComponent = computed(() => {
      const slug = stockComponent.value.replaceAll(" ", "-").toLowerCase();
      return "stocks-view-" + slug;
    });

    const setStockComponent = (component) => {
      if (!component) stockComponent.value = "Stocks List";
      stockComponent.value = component;
    };

    const openStockForm = (action) => {
      switch (action) {
        case "add":
          initStockForm();
          toggleStockModal.value = true;
          setStockComponent("Stock Form");
          break;
        case "edit":
          toggleStockModal.value = true;
          setStockComponent("Stock Form");
          break;
        default:
          break;
      }
    };

    return {
      stockComponent,
      productAvailableInStock,
      filters,
      filterOptions,
      filterOnStock,
      filterOnStockOptions,
      isLoading,
      toggleStockModal,
      showToast,
      currentComponent,

      itemView,
      itemViewOptions,
      dataMeta,
      planProductForRelease,
      setStockComponent,
      openStockForm,

      // useShopRemoteData
      products,

      // mqShallShowLeftSidebar
      mqShallShowLeftSidebar,
    };
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-ecommerce.scss";
</style>

<style lang="scss" scoped>
.item-view-radio-group ::v-deep {
  .btn {
    display: flex;
    align-items: center;
  }
}
</style>
